import { generateClient } from '@aws-amplify/api';

export default function useClientAmplify() {
  const clientAmplify = (token) => {
    const authToken = "Bearer " + token;
    return generateClient({
        authMode: 'lambda',
        authToken
    });
  } 

  return [clientAmplify];
}
